import {
  Alert,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from "@mui/material";

const PAGE_BG = "transparent";

/**
 * Shared page shell for Contractor Portal pages.
 */
const ContractorPortalPageShell = ({
  title,
  description,
  loading = false,
  error = null,
  placeholderMessage = "این بخش به‌زودی فعال می‌شود.",
  compact = false,
  children,
}) => (
  <Box dir="rtl" sx={{ background: PAGE_BG, minHeight: "100%" }}>
    {!compact && title ? (
      <Typography variant="h5" fontWeight={700}>
        {title}
      </Typography>
    ) : null}
    {!compact && description ? (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
        {description}
      </Typography>
    ) : null}

    {loading ? (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress />
      </Box>
    ) : null}

    {!loading && error ? (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    ) : null}

    {!loading && !error && !children ? (
      <Alert severity="info" sx={{ py: 1 }}>
        {placeholderMessage}
      </Alert>
    ) : null}

    {!loading && children ? children : null}
  </Box>
);

export default ContractorPortalPageShell;
